"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.bold.js");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactDeviceDetect = require("react-device-detect");
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _icon = _interopRequireDefault(require("@gravity/icon"));
var _inputButton = _interopRequireWildcard(require("@gravity/input-button"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _jsxFileName = "/codebuild/output/src2620446080/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/AdvantageCode/lib/AdvantageCode.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8,
  _templateObject9,
  _templateObject10,
  _templateObject11,
  _templateObject12,
  _templateObject13;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_210792wbb8() {
  var path = "/codebuild/output/src2620446080/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/AdvantageCode/lib/AdvantageCode.js";
  var hash = "e00e93eb8761f9c4ea92ac693e9de3b5226e6895";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src2620446080/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/AdvantageCode/lib/AdvantageCode.js",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 22
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "1": {
        start: {
          line: 20,
          column: 34
        },
        end: {
          line: 36,
          column: 2
        }
      },
      "2": {
        start: {
          line: 29,
          column: 26
        },
        end: {
          line: 29,
          column: 50
        }
      },
      "3": {
        start: {
          line: 38,
          column: 23
        },
        end: {
          line: 82,
          column: 1
        }
      },
      "4": {
        start: {
          line: 51,
          column: 8
        },
        end: {
          line: 52,
          column: 28
        }
      },
      "5": {
        start: {
          line: 54,
          column: 8
        },
        end: {
          line: 54,
          column: 95
        }
      },
      "6": {
        start: {
          line: 84,
          column: 18
        },
        end: {
          line: 101,
          column: 1
        }
      },
      "7": {
        start: {
          line: 103,
          column: 20
        },
        end: {
          line: 110,
          column: 1
        }
      },
      "8": {
        start: {
          line: 112,
          column: 27
        },
        end: {
          line: 153,
          column: 2
        }
      },
      "9": {
        start: {
          line: 155,
          column: 26
        },
        end: {
          line: 167,
          column: 2
        }
      },
      "10": {
        start: {
          line: 162,
          column: 26
        },
        end: {
          line: 162,
          column: 50
        }
      },
      "11": {
        start: {
          line: 171,
          column: 4
        },
        end: {
          line: 171,
          column: 17
        }
      },
      "12": {
        start: {
          line: 172,
          column: 4
        },
        end: {
          line: 172,
          column: 32
        }
      },
      "13": {
        start: {
          line: 173,
          column: 4
        },
        end: {
          line: 173,
          column: 37
        }
      },
      "14": {
        start: {
          line: 177,
          column: 4
        },
        end: {
          line: 177,
          column: 35
        }
      },
      "15": {
        start: {
          line: 180,
          column: 20
        },
        end: {
          line: 184,
          column: 5
        }
      },
      "16": {
        start: {
          line: 185,
          column: 4
        },
        end: {
          line: 187,
          column: 5
        }
      },
      "17": {
        start: {
          line: 186,
          column: 6
        },
        end: {
          line: 186,
          column: 18
        }
      },
      "18": {
        start: {
          line: 188,
          column: 29
        },
        end: {
          line: 188,
          column: 39
        }
      },
      "19": {
        start: {
          line: 189,
          column: 25
        },
        end: {
          line: 189,
          column: 80
        }
      },
      "20": {
        start: {
          line: 190,
          column: 32
        },
        end: {
          line: 190,
          column: 99
        }
      },
      "21": {
        start: {
          line: 191,
          column: 4
        },
        end: {
          line: 222,
          column: 6
        }
      },
      "22": {
        start: {
          line: 212,
          column: 66
        },
        end: {
          line: 212,
          column: 98
        }
      },
      "23": {
        start: {
          line: 226,
          column: 0
        },
        end: {
          line: 231,
          column: 2
        }
      },
      "24": {
        start: {
          line: 233,
          column: 0
        },
        end: {
          line: 236,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 29,
            column: 11
          },
          end: {
            line: 29,
            column: 12
          }
        },
        loc: {
          start: {
            line: 29,
            column: 26
          },
          end: {
            line: 29,
            column: 50
          }
        },
        line: 29
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 50,
            column: 26
          },
          end: {
            line: 50,
            column: 27
          }
        },
        loc: {
          start: {
            line: 51,
            column: 8
          },
          end: {
            line: 52,
            column: 28
          }
        },
        line: 51
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 53,
            column: 15
          },
          end: {
            line: 53,
            column: 16
          }
        },
        loc: {
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 54,
            column: 95
          }
        },
        line: 54
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 162,
            column: 11
          },
          end: {
            line: 162,
            column: 12
          }
        },
        loc: {
          start: {
            line: 162,
            column: 26
          },
          end: {
            line: 162,
            column: 50
          }
        },
        line: 162
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 170,
            column: 2
          },
          end: {
            line: 170,
            column: 3
          }
        },
        loc: {
          start: {
            line: 170,
            column: 21
          },
          end: {
            line: 174,
            column: 3
          }
        },
        line: 170
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 176,
            column: 2
          },
          end: {
            line: 176,
            column: 3
          }
        },
        loc: {
          start: {
            line: 176,
            column: 9
          },
          end: {
            line: 178,
            column: 3
          }
        },
        line: 176
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 179,
            column: 2
          },
          end: {
            line: 179,
            column: 3
          }
        },
        loc: {
          start: {
            line: 179,
            column: 11
          },
          end: {
            line: 223,
            column: 3
          }
        },
        line: 179
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 212,
            column: 61
          },
          end: {
            line: 212,
            column: 62
          }
        },
        loc: {
          start: {
            line: 212,
            column: 66
          },
          end: {
            line: 212,
            column: 98
          }
        },
        line: 212
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 29,
            column: 26
          },
          end: {
            line: 29,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 29,
            column: 26
          },
          end: {
            line: 29,
            column: 40
          }
        }, {
          start: {
            line: 29,
            column: 44
          },
          end: {
            line: 29,
            column: 50
          }
        }],
        line: 29
      },
      "1": {
        loc: {
          start: {
            line: 51,
            column: 8
          },
          end: {
            line: 52,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 51,
            column: 9
          },
          end: {
            line: 51,
            column: 34
          }
        }, {
          start: {
            line: 51,
            column: 38
          },
          end: {
            line: 51,
            column: 79
          }
        }, {
          start: {
            line: 52,
            column: 8
          },
          end: {
            line: 52,
            column: 28
          }
        }],
        line: 51
      },
      "2": {
        loc: {
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 54,
            column: 95
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 54,
            column: 9
          },
          end: {
            line: 54,
            column: 34
          }
        }, {
          start: {
            line: 54,
            column: 38
          },
          end: {
            line: 54,
            column: 73
          }
        }, {
          start: {
            line: 54,
            column: 78
          },
          end: {
            line: 54,
            column: 95
          }
        }],
        line: 54
      },
      "3": {
        loc: {
          start: {
            line: 106,
            column: 4
          },
          end: {
            line: 109,
            column: 5
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 106,
            column: 4
          },
          end: {
            line: 106,
            column: 12
          }
        }, {
          start: {
            line: 107,
            column: 4
          },
          end: {
            line: 109,
            column: 5
          }
        }],
        line: 106
      },
      "4": {
        loc: {
          start: {
            line: 162,
            column: 26
          },
          end: {
            line: 162,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 162,
            column: 26
          },
          end: {
            line: 162,
            column: 40
          }
        }, {
          start: {
            line: 162,
            column: 44
          },
          end: {
            line: 162,
            column: 50
          }
        }],
        line: 162
      },
      "5": {
        loc: {
          start: {
            line: 185,
            column: 4
          },
          end: {
            line: 187,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 185,
            column: 4
          },
          end: {
            line: 187,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 185
      },
      "6": {
        loc: {
          start: {
            line: 189,
            column: 25
          },
          end: {
            line: 189,
            column: 80
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 189,
            column: 50
          },
          end: {
            line: 189,
            column: 63
          }
        }, {
          start: {
            line: 189,
            column: 66
          },
          end: {
            line: 189,
            column: 80
          }
        }],
        line: 189
      },
      "7": {
        loc: {
          start: {
            line: 190,
            column: 32
          },
          end: {
            line: 190,
            column: 99
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 190,
            column: 57
          },
          end: {
            line: 190,
            column: 82
          }
        }, {
          start: {
            line: 190,
            column: 85
          },
          end: {
            line: 190,
            column: 99
          }
        }],
        line: 190
      },
      "8": {
        loc: {
          start: {
            line: 210,
            column: 27
          },
          end: {
            line: 210,
            column: 87
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 210,
            column: 52
          },
          end: {
            line: 210,
            column: 75
          }
        }, {
          start: {
            line: 210,
            column: 78
          },
          end: {
            line: 210,
            column: 87
          }
        }],
        line: 210
      },
      "9": {
        loc: {
          start: {
            line: 212,
            column: 66
          },
          end: {
            line: 212,
            column: 98
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 212,
            column: 66
          },
          end: {
            line: 212,
            column: 83
          }
        }, {
          start: {
            line: 212,
            column: 87
          },
          end: {
            line: 212,
            column: 98
          }
        }],
        line: 212
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0],
      "2": [0, 0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e00e93eb8761f9c4ea92ac693e9de3b5226e6895"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_210792wbb8 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_210792wbb8();
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var StyledWrapper = (cov_210792wbb8().s[0]++, _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  justify-content: center;\n  background-color: inherit;\n  color: var(--textColor, #2c3e50);\n"]))));
var StyledMessageTitleWrapper = (cov_210792wbb8().s[1]++, (0, _utils.withThemedStyles)(_styledComponents.default.div, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n    display: flex;\n    flex-direction: column;\n    font-size: 0.75rem;\n    line-height: 1rem;\n    margin: 0.5rem 0;\n  "])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n    gap: ", ";\n    display: flex;\n    flex-direction: row;\n    font-size: ", ";\n    line-height: ", ";\n    color: var(--textColor, 2c3e50);\n  "])), function (_ref) {
  var theme = _ref.theme;
  cov_210792wbb8().f[0]++;
  cov_210792wbb8().s[2]++;
  return (cov_210792wbb8().b[0][0]++, theme.spacingX) || (cov_210792wbb8().b[0][1]++, '12px');
}, _themeMapper.evolutionTheme.typography.caption1.fontSize, _themeMapper.evolutionTheme.typography.caption1.lineHeight))));
var ContentWrapper = (cov_210792wbb8().s[3]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: 'stx-AdvantageCode'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-wrap: wrap;\n      position: relative;\n\n      background-color: ", ";\n      color: ", ";\n      font-size: 0.75rem;\n    "])), function (props) {
  cov_210792wbb8().f[1]++;
  cov_210792wbb8().s[4]++;
  return (cov_210792wbb8().b[1][0]++, props.theme.advantageCode) && (cov_210792wbb8().b[1][1]++, props.theme.advantageCode.backgroundColor) || (cov_210792wbb8().b[1][2]++, 'rgb(230, 230, 230)');
}, function (props) {
  cov_210792wbb8().f[2]++;
  cov_210792wbb8().s[5]++;
  return (cov_210792wbb8().b[2][0]++, props.theme.advantageCode) && (cov_210792wbb8().b[2][1]++, props.theme.advantageCode.textColor) || (cov_210792wbb8().b[2][2]++, 'rgb(59, 61, 64)');
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-wrap: wrap;\n      position: relative;\n      gap: ", "px ", "px;\n      width: 100%;\n      padding: 6px 16px;\n      max-width: ", "px;\n      button.g-Button {\n        text-transform: uppercase;\n      }\n      @media (max-width: ", "px) {\n        padding: 12px 16px;\n        justify-content: flex-start;\n        div {\n          margin: 0;\n        }\n        .stx-CloseIconContainer {\n          top: 15px;\n        }\n      }\n    "])), _themeMapper.evolutionTheme.spacings.md, _themeMapper.evolutionTheme.spacings.xxl, _themeMapper.evolutionTheme.breakpoints.xl, _themeMapper.evolutionTheme.breakpoints.md))));
var TitleSpan = (cov_210792wbb8().s[6]++, (0, _utils.withThemedStyles)(_styledComponents.default.span.attrs({
  className: 'stx-TitleSpan'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n      font-weight: bold;\n      margin-right: 1rem;\n      @media all and (max-width: 800px) {\n        margin-top: 0.5rem;\n        margin-bottom: 0.5rem;\n      }\n    "])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n      font-weight: ", ";\n    "])), _themeMapper.evolutionTheme.fontWeight.bold))));
var TextMessage = (cov_210792wbb8().s[7]++, _styledComponents.default.span.attrs({
  className: 'stx-TextMessage'
})(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n  ", ";\n"])), (cov_210792wbb8().b[3][0]++, _reactDeviceDetect.isMobile) && (cov_210792wbb8().b[3][1]++, (0, _styledComponents.css)(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n      display: none;\n    "]))))));
var CloseIconContainer = (cov_210792wbb8().s[8]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: 'stx-CloseIconContainer'
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\n    display: flex;\n    float: right;\n    cursor: pointer;\n    opacity: 0.5;\n    position: absolute;\n    right: 7px;\n    :hover {\n      opacity: 1;\n    }\n    svg {\n      width: 18px;\n    }\n    @media screen and (-ms-high-contrast: active), (forced-colors: active) {\n      -ms-high-contrast-adjust: none;\n      forced-color-adjust: none;\n      background-color: white !important;\n    }\n  "])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2.default)(["\n    display: flex;\n    float: right;\n    cursor: pointer;\n    opacity: 0.5;\n    position: absolute;\n    right: 16px; // follow the spacing of the section\n    :hover {\n      opacity: 1;\n    }\n    svg {\n      width: 18px;\n    }\n    @media screen and (-ms-high-contrast: active), (forced-colors: active) {\n      -ms-high-contrast-adjust: none;\n      forced-color-adjust: none;\n      background-color: white !important;\n    }\n  "]))))));
var StyledInputButton = (cov_210792wbb8().s[9]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_inputButton.default), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2.default)(["\n    > button {\n      text-transform: capitalize;\n    }\n  "])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2.default)(["\n    gap: ", ";\n    > button {\n      text-transform: capitalize;\n    }\n  "])), function (_ref2) {
  var theme = _ref2.theme;
  cov_210792wbb8().f[3]++;
  cov_210792wbb8().s[10]++;
  return (cov_210792wbb8().b[4][0]++, theme.spacingX) || (cov_210792wbb8().b[4][1]++, '12px');
}))));
var AdvantageCode = /*#__PURE__*/function (_Component) {
  function AdvantageCode(props) {
    var _this;
    (0, _classCallCheck2.default)(this, AdvantageCode);
    cov_210792wbb8().f[4]++;
    cov_210792wbb8().s[11]++;
    _this = _callSuper(this, AdvantageCode, [props]);
    cov_210792wbb8().s[12]++;
    _this.state = {
      show: true
    };
    cov_210792wbb8().s[13]++;
    _this.hide = _this.hide.bind(_this);
    return _this;
  }
  (0, _inherits2.default)(AdvantageCode, _Component);
  return (0, _createClass2.default)(AdvantageCode, [{
    key: "hide",
    value: function hide() {
      cov_210792wbb8().f[5]++;
      cov_210792wbb8().s[14]++;
      this.setState({
        show: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      cov_210792wbb8().f[6]++;
      var message = (cov_210792wbb8().s[15]++, {
        closeBtnAltText: this.props.intl.formatMessage({
          id: 'gravity.promotionalCode.closeIcon.altText'
        })
      });
      cov_210792wbb8().s[16]++;
      if (!this.state.show) {
        cov_210792wbb8().b[5][0]++;
        cov_210792wbb8().s[17]++;
        return null;
      } else {
        cov_210792wbb8().b[5][1]++;
      }
      var _ref3 = (cov_210792wbb8().s[18]++, this.props),
        themeQueries = _ref3.themeQueries;
      var OuterWrapper = (cov_210792wbb8().s[19]++, themeQueries.EVOLUTION ? (cov_210792wbb8().b[6][0]++, StyledWrapper) : (cov_210792wbb8().b[6][1]++, _react.default.Fragment));
      var MessageTitleWrapper = (cov_210792wbb8().s[20]++, themeQueries.EVOLUTION ? (cov_210792wbb8().b[7][0]++, StyledMessageTitleWrapper) : (cov_210792wbb8().b[7][1]++, _react.default.Fragment));
      cov_210792wbb8().s[21]++;
      return /*#__PURE__*/_react.default.createElement(OuterWrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 192,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react.default.createElement(ContentWrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 193,
          columnNumber: 9
        }
      }, /*#__PURE__*/_react.default.createElement(MessageTitleWrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 194,
          columnNumber: 11
        }
      }, /*#__PURE__*/_react.default.createElement(TitleSpan, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 195,
          columnNumber: 13
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.AdvantageCode.title",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 196,
          columnNumber: 15
        }
      })), /*#__PURE__*/_react.default.createElement(TextMessage, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 198,
          columnNumber: 13
        }
      }, /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: "promo_code_input",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 199,
          columnNumber: 15
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.AdvantageCode.text",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 200,
          columnNumber: 17
        }
      })))), /*#__PURE__*/_react.default.createElement(StyledInputButton, {
        inputId: "promo_code_input",
        onValueSubmit: this.props.onValueSubmit,
        submitOnEnter: true,
        buttonMessageId: "gravity.AdvantageCode.button",
        inputPlaceholderId: "gravity.AdvantageCode.placeholder",
        buttonVariant: themeQueries.EVOLUTION ? (cov_210792wbb8().b[8][0]++, _inputButton.ButtonVariant.secondary) : (cov_210792wbb8().b[8][1]++, undefined),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 204,
          columnNumber: 11
        }
      }), /*#__PURE__*/_react.default.createElement(CloseIconContainer, {
        onClick: this.hide,
        onKeyDown: function onKeyDown(e) {
          cov_210792wbb8().f[7]++;
          cov_210792wbb8().s[22]++;
          return (cov_210792wbb8().b[9][0]++, e.key === 'Enter') && (cov_210792wbb8().b[9][1]++, _this2.hide());
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 212,
          columnNumber: 11
        }
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        iconName: "close",
        "aria-label": message.closeBtnAltText,
        tabIndex: "0",
        role: "button",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 213,
          columnNumber: 13
        }
      }))));
    }
  }]);
}(_react.Component);
cov_210792wbb8().s[23]++;
AdvantageCode.propTypes = {
  /** Action to call when submit advantage code */
  onValueSubmit: _propTypes.default.func.isRequired,
  intl: _reactIntl.intlShape.isRequired,
  themeQueries: _utils.WithThemeQueriesType
};
cov_210792wbb8().s[24]++;
AdvantageCode.defaultProps = {
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT,
  themeQueries: {}
};
var _default = exports.default = (0, _styledComponents.withTheme)((0, _reactIntl.injectIntl)((0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)(AdvantageCode))));